/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { Image } from 'antd';
import NotFoundImage from './not-found.png';
import './styles.css';

const ProductCarousel = ({ images, product }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isPdf] = useState(product.type === 'attachment' && product.fileType === 'application/pdf');

  return (
    <div className="clients-v2-collection-product-carousel">
      {!images?.length && (
        <div className="clients-v2-collection-product-carousel--image">
          <Image src={isPdf ? 'https://dashboard-v2-images.s3.us-east-1.amazonaws.com/pdf-fallback.svg' : NotFoundImage} width={300} height={300} preview={false} />
        </div>
      )}

      {!!images?.length && (
        <>
          <div className="clients-v2-collection-product-carousel--selector">
            {images.map((image, index) => (
              <Image
                key={index}
                src={image}
                width={50}
                height={50}
                preview={false}
                fallback={isPdf ? 'https://dashboard-v2-images.s3.us-east-1.amazonaws.com/pdf-fallback.svg' : NotFoundImage}
                onClick={() => setSelectedIndex(index)}
                className="clients-v2-collection-product-carousel--thumbnail"
              />
            ))}
          </div>

          <Image
            src={images[selectedIndex]}
            width={300}
            height={300}
            fallback={isPdf ? 'https://dashboard-v2-images.s3.us-east-1.amazonaws.com/pdf-fallback.svg' : NotFoundImage}
            className="clients-v2-collection-product-carousel--image"
            preview={isPdf ? false : true} // if pdf disable preview
            style={{ cursor: isPdf ? 'pointer' : 'default' }}
            onClick={e => {
              if (isPdf) {
                e.preventDefault();
                e.stopPropagation();
                window.open(images[selectedIndex], '_blank');
              }
            }}
          />
        </>
      )}
    </div>
  );
};

export default ProductCarousel;
